import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deletePromocodeApi = (data, callback, errorCallBack) => { 
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.PROMOCODE.DELETE_PROMOCODE,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deletePromocodeApi
